import { render, staticRenderFns } from "./Fast_verify.vue?vue&type=template&id=06412d13&"
import script from "./Fast_verify.vue?vue&type=script&lang=js&"
export * from "./Fast_verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports